export default __webpack_public_path__ + "static/media/glyphicons-halflings-regular.82b1212e.woff";